export const promoBannerSizesMultiSelectTranslationKeys = {
  promoAllSizesPlaceholder: 'promo.all-banner-sizes-placeholder',
  promoBannerSizesLabel: 'promo.banner-sizes-label',
}
